import { render } from "./MiBackToTopBtn.vue?vue&type=template&id=7729beb2&scoped=true"
import script from "./MiBackToTopBtn.vue?vue&type=script&lang=js"
export * from "./MiBackToTopBtn.vue?vue&type=script&lang=js"

import "./MiBackToTopBtn.vue?vue&type=style&index=0&id=7729beb2&scoped=true&lang=css"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7729beb2"]])

export default __exports__